<template>
  <div>
    <!-- 顶部信息栏 -->
    <div class="top-bar">
      <div class="container top-bar-content">
        <div class="flex-center" style="gap: 8px;">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
          </svg>
          <span>客服电话：400-655-4008</span>
        </div>
      </div>
    </div>

    <!-- 头部 Logo与搜索 -->
    <header class="header">
      <div class="container header-inner">
        <div class="logo-group">
          <img :src="logo" alt="弘善庆堂互联网医院" class="logo-main">
          <img :src="logomid" alt="互联网医院" class="logo-mid-mobile">
        </div>
        <img :src="logomid" alt="互联网医院" class="logo-mid-desktop">
        <div class="search-box">
          <span style="color: var(--text-muted); margin-right: 8px;">站内搜索：</span>
          <div class="search-input-group">
            <input type="text" placeholder="请输入检索关键..." v-model="searchKeyword">
            <button @click="handleSearch">
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
              </svg>
              搜索
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- 导航栏 -->
    <nav class="nav-bar">
      <div class="container">
        <ul class="nav-list hide-scrollbar">
          <li v-for="(item, idx) in navItems" :key="idx">
            <a href="#" :class="{ active: item.active }" @click.prevent="handleNavClick(idx)">{{ item.name }}</a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 列表内容区域 -->
    <div class="list-wrapper">
      <div class="container">
        <div class="list-card">
          <div class="list-header">
            <h1 class="list-title">{{ pageTitle }}</h1>
          </div>

          <div class="list-body" v-if="pagedList.length > 0">
            <div
              v-for="(item, idx) in pagedList"
              :key="idx"
              class="list-item"
              @click="goDetail(item.id)"
            >
              <span class="item-dot"></span>
              <span class="item-title">{{ item.content }}</span>
              <span class="item-time" v-if="item.created">{{ formatTime(item.created) }}</span>
            </div>
          </div>

          <div class="list-body empty-tip" v-else>
            <p>暂无内容</p>
          </div>

          <!-- 分页 -->
          <div class="pagination" v-if="totalPages > 1">
            <button
              class="page-btn"
              :disabled="currentPage === 1"
              @click="changePage(1)"
            >首页</button>
            <button
              class="page-btn"
              :disabled="currentPage === 1"
              @click="changePage(currentPage - 1)"
            >上一页</button>
            <button
              v-for="(page, idx) in visiblePages"
              :key="idx"
              class="page-btn"
              :class="{ active: page === currentPage, ellipsis: page === '...' }"
              :disabled="page === '...'"
              @click="page !== '...' && changePage(page)"
            >{{ page }}</button>
            <button
              class="page-btn"
              :disabled="currentPage === totalPages"
              @click="changePage(currentPage + 1)"
            >下一页</button>
            <button
              class="page-btn"
              :disabled="currentPage === totalPages"
              @click="changePage(totalPages)"
            >末页</button>
            <span class="page-info">{{ currentPage }} / {{ totalPages }} 页</span>
          </div>

          <div class="list-footer">
            <button class="back-btn" @click="goBack">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" style="width: 18px; height: 18px; margin-right: 6px;">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              返回首页
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container footer-content">
        <div class="footer-flex">
          <div class="footer-left-group">
            <div class="footer-illustration">
              <img :src="imgUrl+'systemImg/foot3.png'" alt="中医插画">
            </div>
            <div class="qr-group">
              <div class="qr-box"><img :src="imgUrl+'systemImg/xcx.png'" alt="小程序二维码"></div>
              <div class="qr-box"><img :src="imgUrl+'systemImg/gzh.png'" alt="公众号二维码"></div>
            </div>
          </div>
          <div class="footer-right-group">
            <div class="footer-img-row">
              <img :src="imgUrl+'systemImg/foot1.png'" alt="资质荣誉" class="footer-img-1">
            </div>
            <div class="footer-img-row">
              <img :src="imgUrl+'systemImg/foot2.png'" alt="联系方式与地址" class="footer-img-2">
            </div>
          </div>
        </div>
      </div>
      <div class="copyright container">
        Copyright © 2025hongshanqingtang.com 版权所有. 鄂ICP备05019014号-1 鄂公网安备 35020302033006号
      </div>
    </footer>
  </div>
</template>

<script>
import logo from '@/assets/logo.jpg'
import logomid from '@/assets/logomid.png'
import {cdnUrl} from '@/utils/commons.js'

export default {
  name: 'NewsList',
  data() {
    return {
      logo: logo,
      logomid: logomid,
      imgUrl: cdnUrl + '/netImg/',
      searchKeyword: '',
      pageTitle: '资讯列表',
      netImgId: null,
      allList: [],
      currentPage: 1,
      pageSize: 10,
      navItems: [
        { name: '首页', active: false },
        { name: '医院简介', active: false },
        { name: '门诊特色', active: false },
        { name: '科室介绍', active: false },
        { name: '家庭医生', active: false },
        { name: '联系我们', active: false }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.allList.length / this.pageSize)
    },
    pagedList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.allList.slice(start, start + this.pageSize)
    },
    visiblePages() {
      const total = this.totalPages
      const current = this.currentPage
      const pages = []
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i)
      } else if (current <= 4) {
        for (let i = 1; i <= 5; i++) pages.push(i)
        pages.push('...')
        pages.push(total)
      } else if (current >= total - 3) {
        pages.push(1)
        pages.push('...')
        for (let i = total - 4; i <= total; i++) pages.push(i)
      } else {
        pages.push(1)
        pages.push('...')
        for (let i = current - 1; i <= current + 1; i++) pages.push(i)
        pages.push('...')
        pages.push(total)
      }
      return pages
    }
  },
  created() {
    this.initParams()
    this.getList()
  },
  methods: {
    initParams() {
      const query = this.$route.query
      this.netImgId = query.netImgId ? parseInt(query.netImgId) : null
      this.pageTitle = query.title || '资讯列表'
    },
    async getList() {
      try {
        const res = await this.$axios.get('/news/listByNetImgId')
        if (res.data.code === 0 && res.data.data) {
          const map = res.data.data
          this.allList = this.netImgId != null ? (map[this.netImgId] || []) : []
        } else {
          this.allList = []
        }
      } catch (e) {
        console.error(e)
        this.allList = []
      }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goDetail(id) {
      this.$router.push('/news/' + id)
    },
    goBack() {
      this.$router.push('/')
    },
    handleNavClick(idx) {
      if (idx === 0) {
        this.$router.push('/')
      } else {
        this.navItems.forEach((item, index) => {
          item.active = (index === idx)
        })
      }
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        alert(`搜索：${this.searchKeyword}`)
      } else {
        alert('请输入搜索关键词')
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '--'
      const date = new Date(timestamp * 1000)
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
a { text-decoration: none; color: inherit; }
ul { list-style: none; }
img { max-width: 100%; height: auto; display: block; }

.container {
  max-width: 1820px;
  width: 100%;
  margin: 0 auto;
  padding: 0 42px;
}
.flex-center { display: flex; align-items: center; justify-content: center; }
.hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
.hide-scrollbar::-webkit-scrollbar { display: none; }

/* 顶部信息栏 */
.top-bar {
  background-color: var(--brand-red, #c8161d);
  color: white;
  font-size: 18px;
  padding: 16px 0;
  position: relative;
  z-index: 10;
}
.top-bar-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}
.top-bar svg { width: 22px; height: 22px; }

/* 头部 */
.header {
  padding: 28px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 20;
}
.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  min-height: 91px;
}
.logo-group {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 30;
  margin-left: 48px;
}
.logo-main {
  height: 130px;
  width: auto;
  object-fit: contain;
  margin-top: -52px;
  filter: drop-shadow(0 6px 5px rgba(0,0,0,0.08));
  background: white;
  border-radius: 50%;
  flex-shrink: 0;
}
.logo-mid-mobile { height: 65px; }
.logo-mid-desktop { display: none; }
.search-box { display: none; }

/* 导航栏 */
.nav-bar {
  top: 0;
  z-index: 40;
  margin-bottom: 10px;
}
.nav-list {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  justify-content: space-between;
  font-size: 19px;
  font-weight: 500;
  color: var(--brand-red, #c8161d);
}
.nav-list li { flex: 1; text-align: center; }
.nav-list a {
  display: inline-block;
  padding: 16px 14px;
  transition: color 0.3s;
}
.nav-list a:hover { color: var(--brand-red, #c8161d); }
.nav-list a.active {
  font-weight: 700;
  border-bottom: 3px solid var(--brand-red, #c8161d);
}

/* 列表区域 */
.list-wrapper {
  background-color: #f5f5f5;
  padding: 40px 0;
  min-height: 500px;
}
.list-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 6px 25px -8px rgba(0,0,0,0.12);
  border: 1px solid #e5e7eb;
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}
.list-header {
  border-bottom: 2px solid rgba(168, 18, 24, 0.15);
  padding-bottom: 24px;
  margin-bottom: 24px;
}
.list-title {
  font-size: 28px;
  font-weight: bold;
  color: #1f2937;
  line-height: 1.4;
}

/* 列表项 */
.list-body { min-height: 200px; }
.list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px dashed #d1d5db;
  cursor: pointer;
  transition: color 0.3s;
  font-size: 16px;
  color: #374151;
}
.list-item:hover { color: var(--brand-red, #c8161d); }
.item-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--brand-red, #c8161d);
  flex-shrink: 0;
}
.item-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-time {
  color: #9ca3af;
  font-size: 14px;
  flex-shrink: 0;
}
.empty-tip {
  text-align: center;
  color: #9ca3af;
  padding: 60px 0;
  font-size: 16px;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  flex-wrap: wrap;
}
.page-btn {
  padding: 8px 14px;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}
.page-btn:hover:not(:disabled) {
  border-color: var(--brand-red, #c8161d);
  color: var(--brand-red, #c8161d);
}
.page-btn.active {
  background: var(--brand-red, #c8161d);
  color: white;
  border-color: var(--brand-red, #c8161d);
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-btn.ellipsis {
  border: none;
  background: transparent;
  cursor: default;
  padding: 8px 6px;
}
.page-btn.ellipsis:hover {
  color: #374151;
}
.page-info {
  font-size: 14px;
  color: #6b7280;
  margin-left: 12px;
  white-space: nowrap;
}

/* 返回按钮 */
.list-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
}
.back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 28px;
  background: var(--brand-red, #c8161d);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s, transform 0.2s;
}
.back-btn:hover {
  background: #a81218;
  transform: translateY(-2px);
}

/* 页脚 */
.footer {
  background-color: var(--brand-red, #c8161d);
  color: white;
  margin-top: 0;
}
.footer-content { padding: 32px; }
.footer-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 45px;
}
.footer-left-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 35px;
}
.footer-illustration {
  width: 175px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}
.footer-illustration img { opacity: 0.9; }
.qr-group { display: flex; gap: 26px; }
.qr-box {
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid white;
  padding: 7px;
}
.footer-right-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 35px;
}
.footer-img-row { display: flex; justify-content: center; }
.footer-img-row img { width: 100%; }
.footer-img-1 { max-width: 750px; }
.footer-img-2 { max-width: 750px; }
.copyright {
  border-top: 1px solid rgba(255,255,255,0.3);
  background-color: var(--brand-red, #c8161d);
  padding: 18px;
  text-align: center;
  font-size: 13px;
  color: rgba(255,255,255,0.8);
  font-weight: 300;
  letter-spacing: 0.5px;
}

/* 响应式 */
@media (min-width: 768px) {
  .top-bar { font-size: 20px; }
  .header { padding: 32px 0; }
  .header-inner { min-height: 104px; }
  .logo-group { margin-left: 156px; }
  .logo-main { height: 182px; margin-top: -78px; }
  .logo-mid-mobile { display: none; }
  .logo-mid-desktop {
    display: block;
    height: 84px;
    position: absolute;
    left: 48%;
    transform: translateX(-50%);
    z-index: 20;
  }
  .search-box {
    display: flex;
    align-items: center;
    font-size: 16px;
    z-index: 20;
  }
  .search-input-group {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    border-radius: 7px;
    overflow: hidden;
  }
  .search-input-group input {
    padding: 9px 14px;
    outline: none;
    width: 240px;
    border: none;
    font-size: 15px;
  }
  .search-input-group button {
    background: var(--brand-red, #c8161d);
    color: white;
    padding: 9px 22px;
    border: none;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .search-input-group button:hover { background: #a81218; }
  .search-input-group svg { width: 19px; height: 19px; margin-right: 7px; }

  .nav-list { font-size: 20px; }

  .list-wrapper { padding: 60px 0; }
  .list-card { padding: 60px; }
  .list-title { font-size: 36px; }
  .list-item { font-size: 17px; padding: 18px 0; }
  .item-time { font-size: 15px; }

  .footer-content { padding: 40px 28px; }
  .footer-left-group { flex-direction: row; }
  .footer-illustration { width: 195px; }
  .qr-box { width: 155px; }
  .copyright { font-size: 14px; }
}

@media (min-width: 1280px) {
  .footer-flex { flex-direction: row; gap: 85px; }
}
</style>
